import React from "react";
import Video from "../../video/Video";
import Figure from "../figure";


const GuardStrikesMigrant = () => {
  
  return (
    <Figure maxWidth="var(--text-max-width)">
      <Video
        src="https://cdn.theoutlawocean.com/al-mabani/footage__al-mabani-guard-hitting-detainee.mp4"
        autoplay="autoplay"
        muted="muted"
        loop="loop"
        customPadding="75%"
      />
    </Figure>
  )
}
export default GuardStrikesMigrant;
export { GuardStrikesMigrant }